var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.handleDownload}},[_vm._v("下载")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }